import {useEffect, useRef, useState} from 'react'

export function useStateWithRef<TValue>(initialValue?: TValue) {
  const [state, setState] = useState<TValue>(initialValue)
  const ref = useRef(initialValue)

  useEffect(() => {
    ref.current = state
  }, [state])

  return [state, setState, ref] as const
}
